<template>
    <v-main>
      <AppBar :title="title" :hide-back="true" />
        <v-layout fill-height column>
            <v-container flex-fill fluid>
              <div class="account-title-block">
                <p class="desc">
                  입력하신 정보와 일치하는 아이디 목록입니다.
                </p>
              </div>
              <ul class="list-id">
                <li v-for="(item, index) in idList" :key="index">
                  <!-- 일반 회원 간편로그인 일 경우 -->
                  <b v-if="item.provider !== '' && item.provider !== undefined && item.provider !== null">
                    {{item.provider}} 간편 로그인
                  </b>
                  <span>{{item.userId}}</span>
                  <div class="id-info">
                    <!-- 기업 회원일 경우 -->
                    <dl v-if="item.clientNm !== '' && item.clientNm !== undefined && item.clientNm !== null">
                      <dt>소속 :&nbsp;</dt>
                      <dd>{{item.clientNm}}</dd>
                    </dl>
                    <dl>
                      <dt>가입일 :&nbsp;</dt>
                      <dd>{{item.regDt}}</dd>
                    </dl>
                  </div>
                </li>
              </ul>
            </v-container>
            <div class="footer-btns">
                <p class="text-center secondary--text mb-2">로그인 후 서비스를 이용해주세요</p>
                <BlackBtn x-large str="로그인" @click="goLoginPage"/>
            </div>
        </v-layout>
    </v-main>
</template>
<script>
import store from "@/store";
import BlackBtn from "@/components/btns/BlackBtn";
export default {
	components: {
		BlackBtn,
	},

	data: () => ({
		phone: null
		,userName : null
		,clientNm: null
		,clientNo:null
		,idList : []
    ,title: '기업회원 아이디 찾기'
    }),
	created() {
		this.userName = this.$route.params.userName;
		this.phone = this.$route.params.phone;
		this.clientNm = this.$route.params.clientNm;
		this.clientNo = this.$route.params.clientNo;
		this.getMemberIds(this.userName, this.phone, this.clientNm, this.clientNo);
	},
	mounted() {
		this.clientNm = this.$route.params.clientNm;
    this.title = this.$route.params.title;
	},
	methods : {
		goLoginPage () {
			window.location.href = '/user/login'
		}
		,async getMemberIds(userName, phone, clientNm, clientNo) {
			let outParam;
			if(clientNo !== "" && (clientNm === "" || clientNm === undefined)) {
				outParam = {
						userName: userName
						,mobileNo: phone
						,clientNo: clientNo
				}
			} else {
				outParam = {
						userName: userName
						,mobileNo: phone
						,clientNm : clientNm
				}
			}


			await store.dispatch('getMemberIds', this.$_payload("memberJoinPo", outParam))
				.then(res => {
					if (res.success) {
						this.idList = res.data;

						this.idList.forEach((item) => {
							// if(item.latLoginDt != null && item.latLoginDt != ""){
							// 	item.latLoginDt = item.latLoginDt.substr(0, 10).replaceAll('-', '.')
							// }
							if(item.regDt != null && item.regDt != ""){
								item.regDt = item.regDt.substr(0, 10).replaceAll('-', '.')
							}
						})

					}
				}).catch(error => {
					console.log(error);
				}).finally(() => {

				});
		},

	}

}
</script>
